import { useLanguage } from "@/contexts/LanguageContext";

export default function LanguageToggle() {
  const { lang, setLang } = useLanguage();
  return (
    <div
      data-testid="language-toggle"
      role="group"
      aria-label="Language"
      className="inline-flex items-center border border-white/20 font-mono-plex text-xs"
    >
      <button
        data-testid="lang-de"
        onClick={() => setLang("de")}
        className={`px-3 py-1.5 transition-colors ${
          lang === "de"
            ? "bg-redflag text-white"
            : "bg-transparent text-white/70 hover:bg-white/5"
        }`}
      >
        DE
      </button>
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 transition-colors ${
          lang === "en"
            ? "bg-redflag text-white"
            : "bg-transparent text-white/70 hover:bg-white/5"
        }`}
      >
        EN
      </button>
    </div>
  );
}
